import React, { useEffect, useState } from "react";
import { ErrorMessage, Field, useFormikContext } from "formik";
import { Dropdown } from "primereact/dropdown";

function DropdownComponent(props: any) {
  const { name, label, ...rest } = props;

  const { setFieldTouched, isSubmitting, setFieldValue } = useFormikContext();
  const [isMismatch, setIsMismatch] = useState(false);

  useEffect(() => {
    if (!isSubmitting) return;
    // clear value if its not part of options after options have changed
    if (rest.value != null && typeof rest.value === "string" && rest.value !== "" && !rest.options.some((x: any) => x.value === rest.value)) {
      setFieldValue(name, "");
    }
    setFieldTouched(name, true, true);
  }, [isSubmitting]);

  // run in 2 render cycles incase options is updatingon same cycle as first useEffect
  useEffect(() => {
    if (
      rest.options != null &&
      rest.options.length > 0 &&
      rest.value != null &&
      typeof rest.value === "string" &&
      rest.value !== "" &&
      !rest.options.some((x: any) => x.value == rest.value)
    ) {
      setIsMismatch(true);
    }
  }, [rest.value, rest.options]);

  useEffect(() => {
    if (isMismatch) {
      if (
        rest.options != null &&
        rest.options.length > 0 &&
        rest.value != null &&
        typeof rest.value === "string" &&
        rest.value !== "" &&
        !rest.options.some((x: any) => x.value == rest.value)
      ) {
        setFieldValue(name, "");
      }

      setIsMismatch(false);
    }
  }, [isMismatch, rest.value, rest.options]);

  return (
    <div className="flex flex-column w-full py-2">
      <label htmlFor={name}> {label}</label>
      <Field alt={name} name={name} {...rest} as={Dropdown} className="border-noround" />
      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
export default DropdownComponent;
